import { DiscountRules } from '@shared/app/scripts/services/discount-rules';
import { TimeKeeper } from '@core/app/scripts/services/time-keeper';

export class DiscountRulesManager {
  data = [];
  loaded = false;

  constructor(
    private $log: ng.ILogService,
    private discountRules: DiscountRules,
    private timeKeeper: TimeKeeper,
  ) {}

  init = () => {
    let today = this.timeKeeper.getLocalDate();

    return this.discountRules
      .filter({
        active: true,
        $and: [
          {
            $or: [
              {
                startTime: {
                  $lte: today,
                },
              },
              {
                startTime: '',
              },
            ],
          },
          {
            $or: [
              {
                stopTime: {
                  $gte: today,
                },
              },
              {
                stopTime: '',
              },
            ],
          },
        ],
      })
      .then(
        (data) => {
          this.data = data;
          this.loaded = true;
        },
        (response) => {
          if (response?.status && response.status == 401) {
            this.$log.warn(
              '[Automated Discounts] POS is not authorised for pos_discountrules.',
            );
            return;
          }

          this.$log.error(
            '[Automated Discounts] There was an error loading rules.',
          );
        },
      );
  };
}

/*
 * Service discountRulesManager
 */
angular
  .module('posApp')
  .factory(
    'discountRulesManager',
    (
      $log: ng.ILogService,
      discountRules: DiscountRules,
      timeKeeper: TimeKeeper,
    ) => {
      return new DiscountRulesManager($log, discountRules, timeKeeper);
    },
  );
